var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 0C2.70435 0 1.94129 0.316071 1.37868 0.87868C0.816071 1.44129 0.5 2.20435 0.5 3C0.5 3.79565 0.816071 4.55871 1.37868 5.12132C1.94129 5.68393 2.70435 6 3.5 6C5.165 6 6.5 4.665 6.5 3C6.5 2.20435 6.18393 1.44129 5.62132 0.87868C5.05871 0.316071 4.29565 0 3.5 0Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotLight);
export default __webpack_public_path__ + "static/media/dot-light.271b4f43d4a00d5a4b08373edb1f6872.svg";
export { ForwardRef as ReactComponent };